/**
 * School Zone → Centre Name data (PDP line item properties + cart attributes).
 */
(function () {
  const ZONES = ['North', 'North-East', 'Central', 'East', 'West'];

  const CENTRES_BY_ZONE = {
    North: [
      'Admiralty',
      'Woodgrove',
      'Woodlands 316',
      'Woodlands 551',
      'Woodlands 877',
      'Yishun 366',
      'Yishun 388',
      'Yishun 701',
      'Yishun 865',
    ],
    'North-East': [
      'Ang Mo Kio',
      'Punggol 107',
      'Punggol 168',
      'Punggol Beach',
      'Sengkang',
      'Sengkang 201',
      'Sengkang 205',
      'Sengkang 260',
      'Sengkang 275',
      'Sengkang 439',
      'Serangoon Central',
      "St Anne's",
      'Yio Chu Kang',
    ],
    Central: ['Balestier', 'Bishan', 'Boon Keng', 'Bukit Purmei', 'Potong Pasir', 'Thomson'],
    East: ['Bedok Reservoir', 'Tampines 372', 'Tampines 460', 'Ubi'],
    West: [
      'Bukit Panjang 546',
      'Bukit Panjang 631',
      'Choa Chu Kang',
      'Choa Chu Kang 427',
      'Depot',
      'ITE West',
      'Jurong East 248',
      'Jurong West 660',
      'Jurong West 721',
      'Jurong West 976',
      'Keat Hong 803',
      'Keat Hong 805',
      'Lakeside',
      'Teban Gardens',
      'West Coast',
    ],
  };

  function fillCentreOptions(selectCentre, zone, selectedCentre) {
    selectCentre.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = selectCentre.dataset.placeholder || 'Select centre name';
    selectCentre.appendChild(placeholder);

    if (!zone || !CENTRES_BY_ZONE[zone]) {
      selectCentre.disabled = true;
      selectCentre.value = '';
      selectCentre.removeAttribute('required');
      return;
    }

    const list = CENTRES_BY_ZONE[zone];
    list.forEach(function (name) {
      const opt = document.createElement('option');
      opt.value = name;
      opt.textContent = name;
      if (selectedCentre && selectedCentre === name) {
        opt.selected = true;
      }
      selectCentre.appendChild(opt);
    });
    selectCentre.disabled = false;
    selectCentre.setAttribute('required', 'required');
    if (selectedCentre && !list.includes(selectedCentre)) {
      selectCentre.value = '';
    }
  }

  window.ElinSchoolZone = {
    ZONES: ZONES,
    CENTRES_BY_ZONE: CENTRES_BY_ZONE,
    fillCentreOptions: fillCentreOptions,
  };
})();
